import React from 'react';
import { components } from 'react-select';

import './RecurringMeetingOption.scss';

type Props = {
  children: React.ReactNode;
  data: {
    frequency: string;
  };
};

function RecurringMeetingOption({ children, ...props }: Props) {
  return (
    <components.Option {...props}>
      <div className="RecurringMeetingOption d-flex justify-content-between align-items-center">
        <div className="RecurringMeetingOption__name w-100 mr-2">{children}</div>
        {props.data.frequency && <div className="RecurringMeetingOption__date">{props.data.frequency}</div>}
      </div>
    </components.Option>
  );
}

export default RecurringMeetingOption;
